<template>
  <svg
    class="icon--not-found"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 249.96 250.06"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          class="svg-primary"
          d="M190.39,183l25.23,25.31q16.06,16.1,32.13,32.19c3.42,3.44,2.8,7.68-1.31,9.24-2.61,1-4.46-.35-6.19-2.08q-18.56-18.55-37.13-37.09l-20.06-20.06c-29.22,24.69-62.43,34-99.85,25C56.12,209,34.64,193.77,18.88,170.79-12.2,125.48-4.13,63.24,37.34,27.12a109.05,109.05,0,0,1,145.35,1.26C204.9,48.59,217,73.93,218.53,104S210.19,160.23,190.39,183ZM179.08,39.41c-3.83-3.32-7.39-7-11.52-9.9C139.43,9.87,108.8,4.82,76.47,16.39c-34.73,12.43-56.11,37.5-64,73.54-4.51,20.69-2,40.94,6.74,60.28a90.85,90.85,0,0,0,20.11,28.92c0,.08,0,.18.09.23C61.6,201.1,88.38,210.51,119,207.81c23.77-2.1,44.3-12.05,61.06-29.26,16.56-17,25.72-37.4,27.86-61a96.63,96.63,0,0,0-6.61-44.55A92,92,0,0,0,179.08,39.41Z"
        />
        <path
          class="svg-secondary"
          d="M149.46,69.06c5.33-5.25,10.7-10.48,16-15.77,4.58-4.58,9.09-9.25,13.63-13.88a92,92,0,0,1,22.27,33.64A96.63,96.63,0,0,1,208,117.6c-2.14,23.55-11.3,44-27.86,61-16.76,17.21-37.29,27.16-61.06,29.26-30.66,2.7-57.44-6.71-79.59-28.45-.05-.05-.06-.15-.09-.23,1.8-1.72,3.64-3.4,5.41-5.16Q56,162.78,67.2,151.55c.64-.65,1.21-1.37,1.81-2.05,3.68,2.38,5.39,2.23,8.55-.91q13.2-13.14,26.37-26.31c1.79-1.8,3.59-3.59,5.5-5.48,5.6,5.63,10.94,11,16.3,16.37s10.6,10.61,15.94,15.87c2.57,2.53,5.21,2.72,7.54.71,2.51-2.17,2.46-5.33-.25-8.05q-13.05-13.11-26.16-26.16c-2-2-4.07-3.88-6.53-6.21,1.44-1.2,2.54-2,3.48-2.91Q134.18,92,148.55,77.6C151.66,74.48,151.83,72.64,149.46,69.06Z"
        />
        <path
          class="svg-primary"
          d="M149.46,69.06c2.37,3.58,2.2,5.42-.91,8.54Q134.17,92,119.75,106.42c-.94.94-2,1.71-3.48,2.91,2.46,2.33,4.54,4.22,6.53,6.21q13.11,13,26.16,26.16c2.71,2.72,2.76,5.88.25,8.05-2.33,2-5,1.82-7.54-.71-5.34-5.26-10.64-10.57-15.94-15.87s-10.7-10.74-16.3-16.37c-1.91,1.89-3.71,3.68-5.5,5.48q-13.19,13.16-26.37,26.31c-3.16,3.14-4.87,3.29-8.55.91-2-3.45-1.79-5.34,1.07-8.2q15.11-15.11,30.21-30.22c.52-.52,1-1.09,1.67-1.84C95.23,102.57,88.61,96,82,89.43q-6.1-6.08-12.17-12.21c-2.66-2.7-2.85-5.63-.61-7.93s5.29-2.05,7.93.58q15,14.91,29.88,29.85a25.83,25.83,0,0,1,2.17,3.06c2.58-2.81,4.53-5.07,6.63-7.19q12.67-12.77,25.44-25.45C144.15,67.27,146,67,149.46,69.06Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "SvgIconNotFound",
  }
</script>
